import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { IVendor } from '../../../../types';
import { LILI_INVOICES_ID } from '../../constants';
import { VIEWS_MAP } from '../../../../router/constants';

interface IProps {
  vendorDetails: IVendor;
  vendorImage: string;
}

const VendorTile = ({ vendorDetails, vendorImage }: IProps) => {
  const navigate = useNavigate();

  return (
    <div
      role='presentation'
      className='w-[217px] h-[144px] border rounded-[12px] border-outline-primary-bw-03 cursor-pointer p-[24px] flex flex-col gap-[16px] shadow-sm hover:bg-surface-primary-bw-01'
      onClick={() => {
        if (vendorDetails.id === LILI_INVOICES_ID) {
          navigate(`/${VIEWS_MAP.INVOICES}`, { state: { from: '/app-center' } });
        } else {
          navigate(`${VIEWS_MAP.INSTRUCTIONS}/${vendorDetails.id}`);
        }
      }}
    >
      <img src={vendorImage} alt={vendorDetails.logoUrl} className='h-[56px] w-[56px]' />
      <Heading.H9 fontWeight={FontWeight.MEDIUM}>{vendorDetails.vendorName}</Heading.H9>
    </div>
  );
};

export default VendorTile;
